import React, { useRef, useEffect } from "react";
import { Bold, Italic, Heading2, List, ListOrdered, Link2 } from "lucide-react";

const exec = (cmd, val = null) => document.execCommand(cmd, false, val);

export default function RichTextEditor({ value, onChange, testid }) {
  const ref = useRef(null);

  // Initialise once on mount so the caret is never reset while typing.
  useEffect(() => {
    if (ref.current) ref.current.innerHTML = value || "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emit = () => onChange(ref.current ? ref.current.innerHTML : "");

  const Btn = ({ icon, cmd, val }) => (
    <button
      type="button"
      onMouseDown={(e) => { e.preventDefault(); exec(cmd, val); emit(); }}
      className="p-2 rounded hover:bg-[var(--vl-obsidian)] text-[var(--vl-stone)] hover:text-[var(--vl-gold)] transition-colors"
    >{icon}</button>
  );

  const addLink = (e) => {
    e.preventDefault();
    const url = window.prompt("URL (https://...):");
    if (url) { exec("createLink", url); emit(); }
  };

  return (
    <div className="border border-[var(--vl-border)] rounded-lg overflow-hidden bg-[var(--vl-obsidian)]">
      <div className="flex items-center gap-0.5 px-2 py-1.5 border-b border-[var(--vl-border)]">
        <Btn icon={<Bold size={15} />} cmd="bold" />
        <Btn icon={<Italic size={15} />} cmd="italic" />
        <Btn icon={<Heading2 size={15} />} cmd="formatBlock" val="<h2>" />
        <Btn icon={<List size={15} />} cmd="insertUnorderedList" />
        <Btn icon={<ListOrdered size={15} />} cmd="insertOrderedList" />
        <button type="button" onMouseDown={addLink} className="p-2 rounded hover:bg-[var(--vl-surface)] text-[var(--vl-stone)] hover:text-[var(--vl-gold)] transition-colors"><Link2 size={15} /></button>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        data-testid={testid}
        onInput={emit}
        onBlur={emit}
        className="vl-rte min-h-[120px] px-4 py-3 text-sm text-[var(--vl-ivory)] focus:outline-none"
      />
    </div>
  );
}
